import React  from 'react';

import CommunicationDetailsContent from "../content/CommunicationDetailsContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function CommunicationDetails() {
    return(
        <>
        <Navbar />
        <CommunicationDetailsContent/>
        <Footer />        
        </>
    );
}

export default CommunicationDetails;